import { Params, useParams } from "react-router-dom";
import { isTaskAssortmentMatrix } from "tm-shared/utils";

import { useAppSelector } from "@/hooks/redux";
import NotFound from "@/routes/Pages/NotFound";

import { AssortmentMatrixPage } from "./AssortmentMatrixPage";

interface AssortmentMatrixParams extends Params {
    marketId: string;
    taskId: string;
}

const AssortmentMatrix = () => {
    const { marketId, taskId } = useParams<AssortmentMatrixParams>();
    const { markets, tasks } = useAppSelector((s) => s.work);

    const safeMarketId = marketId ?? "";
    const safeTaskId = taskId ?? "";

    const currentMarket = markets?.[safeMarketId];
    const currentTask = tasks?.[safeMarketId]?.[safeTaskId];

    if (
        !currentMarket ||
        !currentTask ||
        !isTaskAssortmentMatrix(currentTask)
    ) {
        return <NotFound />;
    }

    return <AssortmentMatrixPage task={currentTask} market={currentMarket} />;
};

export default AssortmentMatrix;
